import React from 'react';

import { css } from '@emotion/css';

import { Sparkline } from 'components/Sparkline';
import { getMonthlyFilledSeries } from 'components/Sparkline/utils';

export function QtyByMonthSparkline<AggItemT>({
  data,
  dateField,
  quantityField,
  seriesTitle,
  height = 32,
  width,
  numPrevYears = 2,
  fullWidth = false,
  showFullYear,
  showAxisLabels,
}: {
  data: AggItemT[] | undefined;
  dateField: keyof AggItemT;
  quantityField: keyof AggItemT;
  seriesTitle?: string;
  height?: number;
  width?: number;
  numPrevYears?: number;
  fullWidth?: boolean;
  showFullYear?: boolean;
  showAxisLabels?: boolean;
}) {
  return data && data.length > 0 ? (
    <Sparkline
      className={css`
        margin-bottom: 12px;
      `}
      height={height}
      width={width}
      fullWidth={fullWidth}
      series={getMonthlyFilledSeries({
        data,
        dateField,
        valueField: quantityField,
        numPrevYears,
        title: seriesTitle,
        formatFn: (val) => String(val),
        showFullYear,
      })}
      showAxisLabels={showAxisLabels}
    />
  ) : null;
}
